export default function() {
  /* 表格列头（用 min-width 让整行铺满，不再出现右侧大片空白） */
  return [
    { label: "序号", type: "index", width: 80 },
    { label: "用户ID", prop: "id", minWidth: 120 },
    { label: "openid", prop: "u_openid", minWidth: 200 },
    { label: "手机号", prop: "u_phone", minWidth: 130 },
    { label: "权限", prop: "role_id", slots: "role_id", minWidth: 100 },
    { label: "店铺ID", prop: "store_id", minWidth: 100 },
    { label: "是否禁用", prop: "disable", slots: "disable", minWidth: 100 },
    {
      label: "创建时间",
      prop: "create_time",
      minWidth: 180,
    },
    {
      label: "操作",
      prop: "operation",
      minWidth: 180,
      slots: "operation",
    },
  ];
}
